module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f3a736bef507eda95c472eee99909a6a.gif";